var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapabilitysourceLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 47,
    viewBox: "0 0 273 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_552)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 273,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273 0H0V47H273V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2526 23.5C47.2526 36.4502 36.6991 46.9612 23.6661 46.9612C10.6324 46.96 0 36.4508 0 23.5C0 10.5492 10.6318 0.0394287 23.6661 0.0394287C36.6991 0.0394287 47.2526 10.5499 47.2526 23.5Z",
    fill: "url(#paint0_radial_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1541 33.0643C23.1541 33.5361 22.9175 33.9315 22.5237 34.2062C22.2871 34.3652 21.9729 34.4434 21.6968 34.4434C19.886 34.4434 18.0738 34.4434 16.2241 34.4434C16.1846 34.4434 16.1453 34.4434 16.1058 34.4434C15.3184 34.4045 14.5309 34.4045 13.704 34.4045C13.4286 34.4045 13.1526 34.5216 12.956 34.7205C12.6017 35.0353 12.5229 35.4671 12.6017 35.9007C12.7194 36.4513 12.9172 36.9638 13.1137 37.4756C13.3103 38.0263 13.5469 38.5381 13.7435 39.09C13.8224 39.2859 13.8617 39.5236 13.7829 39.7189C13.704 40.0348 13.4675 40.1125 13.2314 40.1125C12.444 40.073 11.6565 40.033 10.8296 39.9948C10.5142 39.9948 10.1993 39.956 9.84505 39.956C9.80618 39.956 9.76615 39.956 9.72736 39.9166C9.37304 39.8384 9.09697 39.6807 8.82155 39.4454C8.46731 39.13 8.15179 38.7759 7.87637 38.3829C7.28549 37.4374 6.73403 36.4938 6.26204 35.5095C6.14374 35.2736 6.10431 35.0371 6.10431 34.8012C6.10431 34.4082 6.22201 34.1316 6.77407 34.1711C7.24666 34.2099 7.71923 34.2099 8.19182 34.2099H8.23069C9.01814 34.2487 9.76615 34.2487 10.5542 34.2893C10.9474 34.2893 11.3016 34.1305 11.4994 33.7763C11.7749 33.3439 11.8142 32.8727 11.696 32.399C11.5382 31.7295 10.6719 26.2969 10.948 25.2356C11.1057 24.5661 11.6572 24.0142 12.4834 24.0142C13.9406 24.0537 19.8472 24.0142 21.3432 24.0142C22.2095 24.0142 22.8786 24.6437 22.9976 25.4309C23.0364 25.628 23.0364 25.8645 23.0364 26.1004C23.0364 27.8712 23.0364 29.6815 23.0758 31.4523C23.0758 31.6106 23.0758 31.8065 23.0758 31.9648C23.1541 32.3171 23.1929 32.6713 23.1541 33.0643Z",
    fill: "url(#paint1_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7261 40.9372C9.84379 40.9372 9.96265 40.9372 10.1192 40.9372C10.7101 40.9754 14.0965 41.1749 14.4902 41.1749C14.9234 41.1749 15.1994 40.9372 15.1994 40.5448C15.1994 40.307 15.16 40.0724 15.0811 39.8364C14.7268 39.0092 14.4114 38.182 14.136 37.3561C14.0571 37.1596 14.0183 36.9219 13.9782 36.6866C13.9394 36.2141 14.2537 35.7805 14.7262 35.7023C14.8439 35.6641 14.9628 35.7023 15.1199 35.7023C16.6554 35.7023 19.4903 35.7405 21.0259 35.7405C21.1047 35.7405 21.223 35.7405 21.3019 35.7405C22.207 35.7405 22.7979 36.4876 22.8368 37.0407C22.8762 37.5525 22.7979 39.5593 22.8762 40.0717C22.9156 40.2677 22.8762 40.5041 22.8368 40.7012C22.7191 41.056 22.3648 41.3302 21.9711 41.3302C21.223 41.3302 17.56 41.292 17.0486 41.292C16.5766 41.292 16.3399 41.6461 16.4188 42.0397C16.4576 42.2362 16.5365 42.3938 16.6154 42.5509C16.7731 42.7886 16.9309 43.0227 17.088 43.2204C17.4811 43.6917 19.8441 46.4468 19.8835 46.6057C19.4503 46.5663 17.6389 46.2121 16.5359 45.8167C15.945 45.6214 15.2365 45.3454 14.6462 45.1084C13.6221 44.676 12.8741 44.3218 11.9683 43.8099C11.102 43.3363 9.76306 41.4078 9.68423 41.2501C9.64537 41.1718 9.60534 41.1331 9.60534 41.0536C9.52893 41.0166 9.56837 40.9372 9.7261 40.9372Z",
    fill: "url(#paint2_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37171 32.8282C8.62363 32.8282 6.10296 32.75 5.59154 32.75C5.19781 32.75 4.96182 32.9083 4.88295 33.2624C4.84352 33.3407 4.84352 33.4189 4.84352 33.4984C4.84352 33.8137 4.92238 34.0896 5.04008 34.4044C5.90701 36.9218 6.85159 38.3009 8.11166 39.8364C8.38708 40.1517 8.66249 40.4277 8.66249 40.5059C8.66249 40.5841 8.62363 40.623 8.50477 40.6636C8.22935 40.7024 7.55959 40.6636 7.48069 40.5841C7.28414 40.3889 7.00871 40.1129 6.81094 39.9146C5.78689 38.9303 4.92117 37.7884 4.09368 36.6477C3.34566 35.5846 2.75476 34.4426 2.20391 33.3007C2.08622 33.0247 1.96731 32.7882 1.81079 32.4741C1.96792 32.4741 2.12565 32.5122 2.24335 32.5122C2.83424 32.5511 2.67711 32.5511 3.2674 32.5923C3.54283 32.5923 3.70056 32.5122 3.81825 32.2764C3.89712 32.1174 3.93595 31.961 3.93595 31.7633C3.93595 31.4479 3.10966 26.4495 2.95193 25.4653C2.9125 25.1499 2.95193 24.7958 3.10966 24.4822C3.2674 24.2063 3.50278 24.0486 3.85708 24.0486C5.23543 24.0486 6.96807 24.0486 8.34638 24.0486C8.81839 24.0486 9.25153 24.2063 9.48815 24.5605C9.76357 24.9535 10.3545 31.568 10.3151 31.8816C10.3169 32.4741 9.92254 32.8689 9.37171 32.8282Z",
    fill: "url(#paint3_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1381 33.0643C24.1381 33.5361 24.3747 33.9315 24.7684 34.2062C25.0044 34.3652 25.3192 34.4434 25.5947 34.4434C27.4056 34.4434 29.2177 34.4434 31.068 34.4434C31.1068 34.4434 31.1468 34.4434 31.1857 34.4434C31.9732 34.4045 32.7612 34.4045 33.5875 34.4045C33.8635 34.4045 34.1389 34.5216 34.3355 34.7205C34.6904 35.0353 34.7687 35.4671 34.6904 35.9007C34.5721 36.4513 34.375 36.9638 34.1778 37.4756C33.9812 38.0263 33.7446 38.5381 33.5481 39.09C33.4692 39.2859 33.4304 39.5236 33.5092 39.7189C33.5875 40.0348 33.8241 40.1125 34.0601 40.1125C34.8476 40.073 35.6356 40.033 36.4618 39.9948C36.7774 39.9948 37.0922 39.956 37.4465 39.956C37.4859 39.956 37.5254 39.956 37.5642 39.9166C37.9191 39.8384 38.1946 39.6807 38.47 39.4454C38.8242 39.13 39.1397 38.7759 39.4151 38.3829C40.006 37.4374 40.5575 36.4938 41.0294 35.5095C41.1478 35.2736 41.1872 35.0371 41.1872 34.8012C41.1872 34.4082 41.0695 34.1316 40.5175 34.1711C40.0455 34.2099 39.5723 34.2099 39.1003 34.2099H39.0608C38.2734 34.2487 37.5254 34.2487 36.7379 34.2893C36.3442 34.2893 35.9899 34.1305 35.7927 33.7763C35.5167 33.3439 35.4773 32.8727 35.5956 32.399C35.7533 31.7295 36.6196 26.2969 36.3436 25.2356C36.1858 24.5661 35.635 24.0142 34.8081 24.0142C33.3515 24.0537 27.4444 24.0142 25.9483 24.0142C25.0814 24.0142 24.4123 24.6437 24.2939 25.4309C24.2552 25.628 24.2552 25.8645 24.2552 26.1004C24.2552 27.8712 24.2552 29.6815 24.2157 31.4523C24.2157 31.6106 24.2157 31.8065 24.2157 31.9648C24.138 32.3171 24.0992 32.6713 24.1381 33.0643Z",
    fill: "url(#paint4_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5654 40.9372C37.4477 40.9372 37.3294 40.9372 37.1723 40.9372C36.5813 40.9754 33.195 41.1749 32.8012 41.1749C32.3681 41.1749 32.0927 40.9372 32.0927 40.5448C32.0927 40.307 32.1314 40.0724 32.2103 39.8364C32.5646 39.0092 32.8801 38.182 33.1555 37.3561C33.2344 37.1596 33.2738 36.9219 33.3133 36.6866C33.3527 36.2141 33.0378 35.7805 32.5652 35.7023C32.4476 35.6641 32.3292 35.7023 32.1721 35.7023C30.6366 35.7023 27.4074 35.7405 25.8718 35.7405C25.7924 35.7405 25.6747 35.7405 25.5958 35.7405C24.6907 35.7405 24.0998 36.4876 24.0604 37.0407C24.0209 37.5525 24.0998 39.5593 24.0209 40.0717C23.9821 40.2677 24.0209 40.5041 24.0604 40.7012C24.1787 41.056 24.5324 41.3302 24.9267 41.3302C25.6747 41.3302 29.7309 41.292 30.2817 41.292C30.7543 41.292 30.9909 41.6461 30.9121 42.0397C30.8726 42.2362 30.7937 42.3938 30.7155 42.5509C30.5578 42.7886 30.4001 43.0227 30.2429 43.2204C29.8492 43.6917 27.4074 46.4874 27.3685 46.6057C27.8017 46.5663 29.6914 46.2121 30.7937 45.8167C31.3847 45.6214 32.0938 45.3454 32.6841 45.1084C33.7082 44.676 34.4562 44.3218 35.3613 43.8099C36.2283 43.3363 37.5666 41.4078 37.6455 41.2501C37.6849 41.1718 37.7243 41.1331 37.7243 41.0536C37.7626 41.0166 37.7231 40.9372 37.5654 40.9372Z",
    fill: "url(#paint5_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9203 32.8284C38.6683 32.8284 41.1884 32.7501 41.6998 32.7501C42.0935 32.7501 42.3301 32.9084 42.409 33.2626C42.4478 33.3408 42.4478 33.419 42.4478 33.4985C42.4478 33.8138 42.3689 34.0898 42.2512 34.4045C41.385 36.9219 40.4398 38.301 39.1803 39.8365C38.9042 40.1518 38.6288 40.4278 38.6288 40.506C38.6288 40.5842 38.6683 40.6231 38.7865 40.6637C39.062 40.7025 39.7317 40.6637 39.8106 40.5842C40.0072 40.389 40.2832 40.1131 40.4804 39.9148C41.5044 38.9305 42.3313 37.7885 43.1582 36.6478C43.9056 35.5847 44.4965 34.4427 45.0874 33.3008C45.2057 33.0249 45.324 32.7883 45.4811 32.4742C45.3234 32.4742 45.1657 32.5124 45.048 32.5124C44.4571 32.5512 44.6148 32.5512 44.0239 32.5925C43.7485 32.5925 43.5908 32.5124 43.4725 32.2765C43.3936 32.1176 43.3548 31.9611 43.3548 31.7634C43.3548 31.4481 44.0246 27.7881 44.2605 25.6231C44.2993 25.2689 44.2605 24.9536 44.1028 24.6388C43.9451 24.3641 43.709 24.2064 43.3548 24.2064C41.9771 24.2064 40.5981 24.2064 39.2203 24.2064C38.7478 24.2064 37.9997 24.4029 37.8426 24.7977C37.7243 25.0725 37.4094 29.4031 36.9368 31.8841C36.8174 32.4742 37.3688 32.869 37.9203 32.8284Z",
    fill: "url(#paint6_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1381 13.974C24.1381 13.5022 24.3747 13.108 24.7684 12.8321C25.0044 12.6738 25.3192 12.5955 25.5947 12.5955C27.4056 12.5955 29.2177 12.5955 31.068 12.5955C31.1068 12.5955 31.1468 12.5955 31.1857 12.5955C31.9732 12.6338 32.7612 12.6338 33.5875 12.6338C33.8635 12.6338 34.1389 12.5167 34.3355 12.319C34.6904 12.003 34.7687 11.5712 34.6904 11.1377C34.5721 10.587 34.375 10.0752 34.1778 9.56331C33.9812 9.01267 33.7446 8.50081 33.5481 7.94952C33.4692 7.75366 33.4304 7.51653 33.5092 7.32004C33.5875 7.00469 33.8241 6.92706 34.0601 6.92706C34.8476 6.96587 35.6356 7.0059 36.4618 7.04411C36.7774 7.04411 37.0922 7.08353 37.4465 7.08353C37.4859 7.08353 37.5254 7.08353 37.5642 7.12294C37.9191 7.20118 38.1946 7.35886 38.47 7.59357C38.8242 7.9095 39.1397 8.2631 39.4151 8.65724C40.006 9.60208 40.5575 10.5463 41.0294 11.5306C41.1478 11.7672 41.1872 12.0025 41.1872 12.239C41.1872 12.6314 41.0695 12.9085 40.5175 12.8684C40.0455 12.8302 39.5723 12.8302 39.1003 12.8302H39.0608C38.2734 12.7915 37.5254 12.7915 36.7379 12.7515C36.3442 12.7515 35.9899 12.9097 35.7927 13.2639C35.5167 13.6963 35.4773 14.1687 35.5956 14.6411C35.7533 15.3107 36.6196 20.7432 36.3436 21.8045C36.1858 22.4741 35.635 23.0259 34.8081 23.0259C33.3515 22.9865 27.4444 23.0259 25.9483 23.0259C25.0814 23.0259 24.4123 22.3964 24.2939 21.608C24.2552 21.4122 24.2552 21.1756 24.2552 20.9385C24.2552 19.1677 24.2552 17.3568 24.2157 15.586C24.2157 15.4283 24.2157 15.2318 24.2157 15.0741C24.138 14.7218 24.0992 14.3282 24.1381 13.974Z",
    fill: "url(#paint7_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5655 6.10172C37.4478 6.10172 37.3296 6.10172 37.1724 6.10172C36.5816 6.06351 33.1951 5.8652 32.8014 5.8652C32.3682 5.8652 32.0928 6.10172 32.0928 6.4953C32.0928 6.73182 32.1317 6.96773 32.2105 7.20364C32.5648 8.03023 32.8802 8.85743 33.1557 9.68404C33.2346 9.88049 33.274 10.117 33.3135 10.3536C33.3528 10.8253 33.038 11.2584 32.5654 11.3372C32.4477 11.3766 32.3294 11.3372 32.1723 11.3372C30.6368 11.3372 27.8407 11.2584 26.3046 11.2195C26.2257 11.2195 26.108 11.2195 26.0292 11.2195C25.1235 11.2195 24.5325 10.4718 24.4937 9.91992C24.4549 9.40806 24.4148 6.37705 24.4937 6.18056C24.6114 5.82638 24.9663 5.55106 25.3606 5.55106C26.108 5.55106 29.7705 5.74755 30.2819 5.74755C30.7545 5.74755 30.9911 5.39338 30.9122 4.99979C30.8728 4.80269 30.794 4.64563 30.7157 4.48795C30.5579 4.25204 30.4002 4.01553 30.2431 3.81843C29.8494 3.34661 27.211 0.511445 27.1721 0.35498C27.6053 0.393187 29.6916 0.826194 30.7945 1.22099C31.3854 1.41748 32.0946 1.69221 32.6849 1.92933C33.709 2.36234 34.457 2.7165 35.3621 3.22895C36.2291 3.70077 37.5674 5.62989 37.6463 5.78757C37.6857 5.86581 37.7251 5.90523 37.7251 5.98406C37.7627 6.02288 37.7233 6.10172 37.5655 6.10172Z",
    fill: "url(#paint8_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9204 14.1711C38.6685 14.1711 41.1886 14.2505 41.7 14.2505C42.0937 14.2505 42.3303 14.0923 42.4092 13.7381C42.448 13.6586 42.448 13.5804 42.448 13.5016C42.448 13.1862 42.3692 12.9103 42.2515 12.5961C41.3851 10.0776 40.4399 8.6991 39.1805 7.16417C38.9045 6.84821 38.6291 6.57349 38.6291 6.49464C38.6291 6.41642 38.6685 6.377 38.7868 6.33697C39.0622 6.29815 39.732 6.33697 39.8109 6.41642C40.0074 6.61291 40.2834 6.88763 40.4805 7.08594C41.5046 8.06959 42.3315 9.21154 43.1584 10.3541C43.9058 11.4166 44.4967 12.5585 45.0876 13.6993C45.2059 13.9752 45.3242 14.2118 45.4814 14.5258C45.3236 14.5258 45.1658 14.4871 45.0481 14.4871C44.4573 14.4482 44.615 14.4482 44.0241 14.4089C43.7487 14.4089 43.591 14.4871 43.4726 14.7236C43.3938 14.8819 43.355 15.0384 43.355 15.2361C43.355 15.5508 44.2213 20.668 44.379 21.6523C44.4178 21.967 44.379 22.3218 44.2213 22.6353C44.0636 22.9113 43.8275 23.069 43.4732 23.069C42.0955 23.069 40.2446 23.0308 38.8663 23.0308C38.3937 23.0308 37.8422 22.9507 37.7239 22.5183C37.3308 21.2581 37.4485 18.2277 36.9765 15.0784C36.857 14.5653 37.369 14.1711 37.9204 14.1711Z",
    fill: "url(#paint9_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1541 13.974C23.1541 13.5022 22.9175 13.108 22.5237 12.8321C22.2871 12.6738 21.9729 12.5955 21.6968 12.5955C19.886 12.5955 18.0738 12.5955 16.2241 12.5955C16.1846 12.5955 16.1453 12.5955 16.1058 12.5955C15.3184 12.6338 14.5309 12.6338 13.704 12.6338C13.4286 12.6338 13.1526 12.5167 12.956 12.319C12.6017 12.003 12.5229 11.5712 12.6017 11.1377C12.7194 10.587 12.9172 10.0752 13.1137 9.56331C13.3103 9.01267 13.5469 8.50081 13.7435 7.94952C13.8224 7.75366 13.8617 7.51653 13.7829 7.32004C13.704 7.00469 13.4675 6.92706 13.2314 6.92706C12.444 6.96587 11.6565 7.0059 10.8296 7.04411C10.5142 7.04411 10.1993 7.08353 9.84505 7.08353C9.80618 7.08353 9.76615 7.08353 9.72736 7.12294C9.37304 7.20118 9.09697 7.35886 8.82155 7.59357C8.46731 7.9095 8.15179 8.2631 7.87637 8.65724C7.28549 9.60208 6.73403 10.5463 6.26204 11.5306C6.14374 11.7672 6.10431 12.0025 6.10431 12.239C6.10431 12.6314 6.22201 12.9085 6.77407 12.8684C7.24666 12.8302 7.71923 12.8302 8.19182 12.8302H8.23069C9.01814 12.7915 9.76615 12.7915 10.5542 12.7515C10.9474 12.7515 11.3016 12.9097 11.4994 13.2639C11.7749 13.6963 11.8142 14.1687 11.696 14.6411C11.5382 15.3107 10.6719 20.7432 10.948 21.8045C11.1057 22.4741 11.6572 23.0259 12.4834 23.0259C13.9406 22.9865 19.8472 23.0259 21.3432 23.0259C22.2095 23.0259 22.8786 22.3964 22.9976 21.608C23.0364 21.4122 23.0364 21.1756 23.0364 20.9385C23.0364 19.1677 23.0364 17.3568 23.0758 15.586C23.0758 15.4283 23.0758 15.2318 23.0758 15.0741C23.1541 14.7218 23.1929 14.3282 23.1541 13.974Z",
    fill: "url(#paint10_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72613 6.10153C9.84382 6.10153 9.96275 6.10153 10.1192 6.10153C10.7102 6.06332 14.0965 5.86501 14.4903 5.86501C14.9234 5.86501 15.1994 6.10153 15.1994 6.49511C15.1994 6.73163 15.1601 6.96754 15.0812 7.20345C14.7269 8.03004 14.4114 8.85724 14.136 9.68385C14.0571 9.8803 14.0183 10.1168 13.9783 10.3534C13.9394 10.8251 14.2537 11.2582 14.7263 11.337C14.844 11.3764 14.9629 11.337 15.12 11.337C16.6555 11.337 19.727 11.2582 21.2625 11.2582C21.3414 11.2582 21.4591 11.2582 21.5379 11.2582C22.4437 11.2582 23.0345 10.5111 23.074 9.95858C23.1129 9.44672 23.1917 6.49511 23.1522 6.25799C23.0345 5.90382 22.6803 5.6291 22.286 5.6291C21.5379 5.6291 17.5606 5.74615 17.0097 5.74615C16.5371 5.74615 16.3012 5.39198 16.3794 4.99899C16.4189 4.80251 16.4978 4.64483 16.5766 4.48655C16.7343 4.25003 16.892 4.01473 17.0486 3.81703C17.4423 3.34581 20.0807 0.511254 20.1202 0.353577C19.687 0.39239 17.6 0.825394 16.4971 1.22019C15.9062 1.41608 15.1976 1.69202 14.6073 1.92853C13.5833 2.36154 12.8353 2.7157 11.9295 3.22876C11.0632 3.69998 9.7243 5.6297 9.64547 5.78738C9.60602 5.74796 9.56657 5.82559 9.56657 5.90443C9.52895 6.02268 9.5684 6.10153 9.72613 6.10153Z",
    fill: "url(#paint11_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37171 14.171C8.62363 14.171 6.10296 14.2505 5.59154 14.2505C5.19781 14.2505 4.96182 14.0921 4.88295 13.738C4.84352 13.6986 4.84352 13.6203 4.84352 13.5409C4.84352 13.2262 4.92238 12.9502 5.04008 12.6361C5.90701 10.1175 6.85159 8.73897 8.11166 7.20407C8.38708 6.88811 8.66249 6.61399 8.66249 6.53455C8.66249 6.45632 8.62363 6.41689 8.50477 6.37687C8.22935 6.33866 7.55959 6.37687 7.48069 6.45632C7.28414 6.6528 7.00871 6.92813 6.81094 7.12584C5.78689 8.10888 4.9606 9.25083 4.13372 10.3928C3.3857 11.4553 2.79481 12.5972 2.20391 13.7392C2.08622 14.0139 1.96731 14.251 1.81079 14.5658C1.96792 14.5658 2.12565 14.5258 2.24335 14.5258C2.83424 14.4876 2.67711 14.4876 3.2674 14.4475C3.54283 14.4475 3.70056 14.5258 3.81825 14.7629C3.89712 14.9212 3.93595 15.0788 3.93595 15.2754C3.93595 15.5913 3.14849 20.4314 2.99137 21.4157C2.95193 21.7316 2.99137 22.0852 3.14849 22.3999C3.30622 22.6753 3.54222 22.833 3.89651 22.833C5.27425 22.833 6.8892 22.9117 8.26756 22.9117C8.73956 22.9117 9.1727 22.7541 9.40933 22.3999C9.72478 21.9663 10.3545 15.4718 10.3151 15.1577C10.3169 14.5652 9.92254 14.171 9.37171 14.171Z",
    fill: "url(#paint12_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9713C0 23.6966 1.30009 23.7761 1.30009 23.7761C1.85094 23.8137 1.92981 24.169 1.92981 24.7215C1.92981 25.391 1.96863 25.9416 2.1658 27.4378C2.36297 29.0121 2.75669 30.2317 2.75669 30.2317C2.87499 30.9013 2.48187 31.2159 2.08754 31.2159L1.30009 31.1772C0.788062 29.5233 0.0394333 27.5549 0 23.9713Z",
    fill: "url(#paint13_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0393066 22.5161C0.0393066 22.7908 1.29935 22.7519 1.29935 22.7519C1.8502 22.7132 1.92907 22.359 1.92907 21.8065C1.9679 21.137 2.00794 20.5857 2.2045 19.0902C2.4411 17.5153 2.83422 16.3351 2.83422 16.3351C2.95252 15.6656 2.59822 15.3114 2.2045 15.3114L1.41705 15.3503C0.945058 16.9658 0.157606 18.9338 0.0393066 22.5161Z",
    fill: "url(#paint14_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2126 23.9713C47.2126 23.6966 45.9131 23.7761 45.9131 23.7761C45.3623 23.8137 45.2834 24.169 45.2834 24.7215C45.2834 25.391 45.244 25.9416 45.0468 27.4378C44.8502 29.0121 44.4559 30.2317 44.4559 30.2317C44.3376 30.9013 44.7313 31.2159 45.125 31.2159L45.9131 31.1772C46.4251 29.5233 47.1738 27.5549 47.2126 23.9713Z",
    fill: "url(#paint15_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2126 22.5161C47.2126 22.7908 45.9531 22.7519 45.9531 22.7519C45.4017 22.7132 45.3228 22.359 45.3228 21.8065C45.284 21.137 45.244 20.5857 45.0474 19.0902C44.8108 17.5153 44.4171 16.3351 44.4171 16.3351C44.2994 15.6656 44.6537 15.3114 45.0474 15.3114L45.8349 15.3503C46.3069 16.9658 47.0949 18.9338 47.2126 22.5161Z",
    fill: "url(#paint16_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6662 4.01531C28.6662 4.13297 28.6274 4.21181 28.5485 4.29125C28.5091 4.32946 28.4308 4.36948 28.3908 4.36948C28.3119 4.4083 28.273 4.4083 28.1942 4.4083C28.1153 4.4083 25.8713 4.4083 23.6266 4.4083C21.3825 4.4083 19.1773 4.4083 19.059 4.4083C18.9801 4.4083 18.9413 4.4083 18.8625 4.36948C18.823 4.36948 18.7442 4.33067 18.7047 4.29125C18.6259 4.21181 18.587 4.13297 18.587 4.01531C18.587 3.89706 18.6259 3.7788 18.6653 3.69996C18.7047 3.62112 18.7442 3.50287 18.823 3.42463C18.823 3.38521 21.7374 0.0776256 21.7374 0.0776256C21.7374 0.0776256 22.2883 0.0394193 22.8392 0C23.3906 0 23.9815 0 23.9815 0C24.4147 0 25.517 0.0782322 25.517 0.0782322C25.517 0.0782322 28.4314 3.38521 28.4314 3.42524C28.4702 3.50347 28.5491 3.58352 28.5886 3.70057C28.6274 3.81822 28.6662 3.89645 28.6662 4.01531Z",
    fill: "url(#paint17_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5863 42.984C18.5863 42.8663 18.6252 42.7881 18.704 42.7093C18.7429 42.6698 18.8217 42.6298 18.8617 42.6298C18.9406 42.5916 18.9795 42.5916 19.0583 42.5916C19.1372 42.5916 21.3819 42.5916 23.6259 42.5916C25.8706 42.5916 28.0752 42.5916 28.1935 42.5916C28.2724 42.5916 28.3112 42.5916 28.3901 42.6298C28.4295 42.6298 28.5078 42.668 28.5478 42.7093C28.6266 42.7881 28.6655 42.8663 28.6655 42.984C28.6655 43.1022 28.6266 43.2217 28.5866 43.2999C28.5478 43.3781 28.5078 43.4976 28.4295 43.5758C28.4295 43.6141 25.5151 46.9223 25.5151 46.9223C25.5151 46.9223 24.4128 46.9999 23.9796 46.9999C23.9402 46.9999 23.783 46.9999 23.5864 46.9999C23.4281 46.9999 23.271 46.9999 23.2315 46.9999C22.9956 46.9999 22.523 46.9611 22.1687 46.9611C21.8933 46.9611 21.6961 46.9229 21.6961 46.9229C21.6961 46.9229 18.7823 43.6171 18.7823 43.5771C18.7429 43.4989 18.664 43.4182 18.6246 43.3012C18.6252 43.1811 18.5863 43.1028 18.5863 42.984Z",
    fill: "url(#paint18_linear_7_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0825 13.4224C72.4936 13.4224 75.6437 15.9816 76.3917 20.0751H73.9105C73.1621 17.2806 70.9569 15.6669 67.9642 15.6669C63.7903 15.6669 61.1125 18.8932 61.1125 23.4998C61.1125 28.0646 63.7903 31.3327 67.9642 31.3327C71.0358 31.3327 73.1616 29.7184 73.871 26.9232H76.3514C75.6034 31.0167 72.493 33.576 68.0819 33.576C62.3332 33.576 58.6319 29.5619 58.6319 23.4998C58.5931 17.5172 62.3338 13.4224 68.0825 13.4224Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.102 31.3328V33.459H90.8424C88.9131 33.459 88.2442 32.633 88.2442 31.2152C87.3381 32.5148 85.8808 33.6161 83.4004 33.6161C80.2108 33.6161 78.0846 32.0411 78.0846 29.4055C78.0846 26.5321 80.0929 24.9178 83.9113 24.9178H88.1651V23.9341C88.1651 22.0456 86.8257 20.9419 84.5817 20.9419C82.5338 20.9419 81.1952 21.8873 80.8805 23.3822H78.4776C78.8319 20.5471 81.1161 18.8951 84.6205 18.8951C88.3225 18.8951 90.4486 20.7453 90.4486 24.0893V30.3103C90.4486 31.0174 90.8029 31.3728 91.3935 31.3728H92.102V31.3328ZM88.0861 26.8456H83.5973C81.5106 26.8456 80.3689 27.5922 80.3689 29.2466C80.3689 30.6645 81.5897 31.6087 83.5182 31.6087C86.3932 31.6087 88.0861 29.9549 88.0861 27.5164V26.8456Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.365 26.2155C108.365 30.625 105.412 33.616 101.434 33.616C98.9936 33.616 97.3395 32.6317 96.4729 31.2533V39.1244H94.1498V19.0115H96.1582L96.4736 21.3336C97.4193 19.9951 98.9936 18.8532 101.435 18.8532C105.412 18.815 108.365 21.5313 108.365 26.2155ZM105.964 26.2155C105.964 23.0674 104.033 20.9024 101.159 20.9024C98.3232 20.9024 96.3946 23.0656 96.3946 26.1761C96.3946 29.3648 98.3232 31.5699 101.159 31.5699C104.033 31.5693 105.964 29.3642 105.964 26.2155Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.274 31.3328V33.459H122.974C121.044 33.459 120.375 32.633 120.375 31.2152C119.469 32.5148 118.012 33.6161 115.532 33.6161C112.343 33.6161 110.216 32.0411 110.216 29.4055C110.216 26.5321 112.225 24.9178 116.044 24.9178H120.296V23.9341C120.296 22.0456 118.958 20.9419 116.713 20.9419C114.666 20.9419 113.327 21.8873 113.012 23.3822H110.689C111.043 20.5471 113.327 18.8951 116.832 18.8951C120.534 18.8951 122.659 20.7453 122.659 24.0893V30.3103C122.659 31.0174 123.013 31.3728 123.604 31.3728H124.274L124.274 31.3328ZM120.258 26.8456H115.77C113.683 26.8456 112.54 27.5922 112.54 29.2466C112.54 30.6645 113.761 31.6087 115.691 31.6087C118.565 31.6087 120.258 29.9549 120.258 27.5164V26.8456Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.457 26.2155C140.457 30.625 137.505 33.6161 133.527 33.6161C131.085 33.6161 129.432 32.6318 128.564 31.2533L128.249 33.4577H126.24V13.6189H128.563V21.3342C129.51 19.9958 131.083 18.8544 133.525 18.8544C137.505 18.815 140.457 21.5313 140.457 26.2155ZM138.055 26.2155C138.055 23.0674 136.125 20.9024 133.251 20.9024C130.415 20.9024 128.486 23.0656 128.486 26.1761C128.486 29.3648 130.415 31.5699 133.251 31.5699C136.127 31.5693 138.055 29.3642 138.055 26.2155Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.261 14.9178C145.261 15.7845 144.591 16.414 143.764 16.414C142.937 16.414 142.267 15.7845 142.267 14.9178C142.267 14.0513 142.937 13.4218 143.764 13.4218C144.593 13.4223 145.261 14.0524 145.261 14.9178ZM144.947 19.012V33.4577H142.624V19.012H144.947Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.419 13.6189V33.459H148.096V13.6189H150.419Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.72 14.9178C156.72 15.7845 156.051 16.414 155.224 16.414C154.396 16.414 153.727 15.7845 153.727 14.9178C153.727 14.0513 154.396 13.4218 155.224 13.4218C156.051 13.4223 156.72 14.0524 156.72 14.9178ZM156.365 19.012V33.4577H154.043V19.012H156.365Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.131 21.1375H158.532V19.0119H161.131V14.9572H163.454V19.0119H167.116V21.1375H163.454V29.6781C163.454 30.8996 163.886 31.3331 165.029 31.3331H167.549V33.4594H164.872C162.077 33.4594 161.092 32.2392 161.092 29.68V21.1375H161.131Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.644 19.012L176.095 30.8214L180.386 19.012H182.868L176.212 35.8993C175.306 38.2214 174.756 39.1256 172.708 39.1256H169.914V37.0005H171.999C173.338 37.0005 173.535 36.6464 174.086 35.308L174.833 33.5765L169.162 19.012H171.644Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.064 27.003C188.222 28.9315 189.718 30.2711 192.159 30.2711C194.128 30.2711 195.546 29.4039 195.546 27.8702C195.546 26.2152 193.931 25.8616 190.624 25.1933C187.277 24.5632 184.323 23.5007 184.323 19.4854C184.323 15.9825 187.394 13.4633 191.726 13.4633C196.136 13.4633 199.365 16.1002 199.444 19.6819H195.27C195.112 18.0287 193.813 16.8486 191.726 16.8486C189.915 16.8486 188.616 17.5951 188.616 19.1312C188.616 20.7444 190.191 21.0998 193.457 21.7286C196.844 22.3587 199.876 23.3836 199.837 27.3584C199.799 30.9795 196.529 33.6157 192.08 33.6157C187.277 33.6157 183.928 30.7811 183.851 26.9235L188.064 27.003Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.374 26.1764C201.374 21.6893 204.406 18.7359 209.052 18.7359C213.699 18.7359 216.731 21.7275 216.731 26.1764C216.731 30.6624 213.699 33.6158 209.052 33.6158C204.406 33.6158 201.374 30.6242 201.374 26.1764ZM212.674 26.1764C212.674 23.6961 211.297 21.9652 209.05 21.9652C206.806 21.9652 205.467 23.6961 205.467 26.1764C205.467 28.6556 206.845 30.3865 209.05 30.3865C211.255 30.3865 212.674 28.6162 212.674 26.1764Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.087 18.8938V33.4595H228.542L228.188 31.6875C227.244 32.8294 225.983 33.6172 223.897 33.6172C220.904 33.6172 218.109 32.0823 218.109 26.7685V18.8549H222.125V26.2955C222.125 28.8917 222.992 30.3096 224.961 30.3096C226.928 30.3096 228.109 28.7352 228.109 26.0583V18.8938H232.087Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.876 18.8936V22.5159H241.302C238.939 22.5159 237.994 24.0903 237.994 26.2941V33.4188H234.017V18.8542H237.64L237.994 21.018C238.782 19.7196 239.924 18.8542 242.207 18.8542H242.876V18.8936Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.319 33.6158C245.711 33.6158 242.798 30.6242 242.798 26.1764C242.798 21.6493 245.751 18.7359 250.359 18.7359C254.296 18.7359 256.817 20.9009 257.408 24.365H253.274C252.919 22.9471 251.896 22.0023 250.359 22.0023C248.273 22.0023 246.933 23.6948 246.933 26.214C246.933 28.6945 248.272 30.4241 250.359 30.4241C251.935 30.4241 252.998 29.4798 253.312 27.9849H257.408C256.816 31.4514 254.296 33.6158 250.319 33.6158Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.48 18.6965C269.891 18.6965 272.924 21.4128 273 25.7034C273 26.137 272.961 26.6088 272.882 27.0813H262.29V27.1989C262.449 29.2839 263.667 30.5829 265.715 30.5829C267.33 30.5829 268.472 29.8758 268.786 28.498H272.724C272.251 31.3325 269.81 33.6152 265.99 33.6152C261.068 33.6152 258.115 30.7018 258.115 26.1746C258.155 21.6499 261.069 18.6965 265.48 18.6965ZM268.984 24.4826C268.708 22.7117 267.449 21.6893 265.637 21.6893C263.905 21.6893 262.605 22.7518 262.366 24.4826H268.984Z",
    fill: "#454545"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7_552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6264 23.5002) scale(23.4038 23.6881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4046,
    stopColor: "#FAFAFA",
    stopOpacity: 0.4086
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#F0F0F1",
    stopOpacity: 0.7697
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9902,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_552",
    x1: 19.8653,
    y1: 27.1088,
    x2: 5.38707,
    y2: 38.1162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4581,
    stopColor: "#EE6A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6476,
    stopColor: "#E26423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    stopColor: "#D35B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#BE4F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_552",
    x1: 22.0175,
    y1: 33.7083,
    x2: 12.8425,
    y2: 46.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4581,
    stopColor: "#EE6A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6476,
    stopColor: "#E26423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    stopColor: "#D35B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#BE4F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_552",
    x1: 19.3106,
    y1: 22.2801,
    x2: 3.24768,
    y2: 34.4923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4581,
    stopColor: "#EE6A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6476,
    stopColor: "#E26423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    stopColor: "#D35B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#BE4F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_552",
    x1: 27.4251,
    y1: 27.1069,
    x2: 41.9034,
    y2: 38.1143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    stopColor: "#26A1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5868,
    stopColor: "#269CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#2492C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    stopColor: "#2086B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#1A78A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    stopColor: "#0E6993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6690"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7_552",
    x1: 20.1241,
    y1: 33.6105,
    x2: 36.2332,
    y2: 45.8578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    stopColor: "#26A1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5868,
    stopColor: "#269CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#2492C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    stopColor: "#2086B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#1A78A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    stopColor: "#0E6993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6690"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7_552",
    x1: 28.2011,
    y1: 22.5567,
    x2: 43.9828,
    y2: 34.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    stopColor: "#26A1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5868,
    stopColor: "#269CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#2492C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    stopColor: "#2086B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#1A78A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    stopColor: "#0E6993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6690"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7_552",
    x1: 27.4257,
    y1: 19.9315,
    x2: 41.904,
    y2: 8.92418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4364,
    stopColor: "#9AC253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6168,
    stopColor: "#93B84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#87AB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#799A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9546,
    stopColor: "#67853A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C7936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7_552",
    x1: 25.0373,
    y1: 12.64,
    x2: 33.7457,
    y2: 1.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4364,
    stopColor: "#9AC253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6168,
    stopColor: "#93B84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#87AB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#799A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9546,
    stopColor: "#67853A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C7936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7_552",
    x1: 27.7736,
    y1: 24.9509,
    x2: 44.0368,
    y2: 12.5866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4364,
    stopColor: "#9AC253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6168,
    stopColor: "#93B84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#87AB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#799A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9546,
    stopColor: "#67853A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C7936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7_552",
    x1: 19.8642,
    y1: 19.9304,
    x2: 5.38597,
    y2: 8.92293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB356A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#D73468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6632,
    stopColor: "#CE3162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7884,
    stopColor: "#C02B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    stopColor: "#AD244F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9752,
    stopColor: "#961B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F183C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7_552",
    x1: 27.0673,
    y1: 13.2365,
    x2: 11.1253,
    y2: 1.11634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB356A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#D73468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6632,
    stopColor: "#CE3162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7884,
    stopColor: "#C02B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    stopColor: "#AD244F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9752,
    stopColor: "#961B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F183C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7_552",
    x1: 19.2037,
    y1: 24.5847,
    x2: 3.30106,
    y2: 12.4945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB356A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#D73468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6632,
    stopColor: "#CE3162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7884,
    stopColor: "#C02B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    stopColor: "#AD244F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9752,
    stopColor: "#961B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F183C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7_552",
    x1: 7.29467,
    y1: 27.1036,
    x2: -0.724232,
    y2: 27.6325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3856,
    stopColor: "#EE6A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5451,
    stopColor: "#E26423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6628,
    stopColor: "#D35B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7593,
    stopColor: "#BE4F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8418,
    stopColor: "#A64223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7_552",
    x1: 7.27886,
    y1: 20.8061,
    x2: 1.08791,
    y2: 18.9349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB356A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#D73468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6632,
    stopColor: "#CE3162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7884,
    stopColor: "#C02B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    stopColor: "#AD244F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9752,
    stopColor: "#961B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F183C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7_552",
    x1: 39.9301,
    y1: 27.1036,
    x2: 46.1208,
    y2: 27.5119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    stopColor: "#26A1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5868,
    stopColor: "#269CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#2492C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    stopColor: "#2086B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#1A78A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    stopColor: "#0E6993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6690"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7_552",
    x1: 39.1024,
    y1: 20.3812,
    x2: 46.4785,
    y2: 18.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4364,
    stopColor: "#9AC253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6168,
    stopColor: "#93B84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#87AB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#799A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9546,
    stopColor: "#67853A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C7936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7_552",
    x1: 22.6001,
    y1: 6.53528,
    x2: 25.5726,
    y2: -0.834187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#9AC253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5415,
    stopColor: "#93B84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6584,
    stopColor: "#87AB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7549,
    stopColor: "#799A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#67853A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    stopColor: "#5C7936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7_552",
    x1: 23.9891,
    y1: 41.1367,
    x2: 22.6808,
    y2: 47.8207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4581,
    stopColor: "#EE6A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6476,
    stopColor: "#E26423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    stopColor: "#D35B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#BE4F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64223"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 47,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapabilitysourceLogo1);
export default __webpack_public_path__ + "static/media/capabilitysource-logo1.f213ae24eab99439342a70a9859c4f36.svg";
export { ForwardRef as ReactComponent };